module.exports = __webpack_public_path__ + "img/logo_bacredomatic.baa6a0c5.jpg";